export const GET_TABLE_DATA = "table/GET_TABLE_DATA";
export const GET_TABLE_DATA_SUCCESS = "table/GET_TABLE_DATA_SUCCESS";
export const GET_TABLE_DATA_ERROR = "table/GET_TABLE_DATA_ERROR";
export const CLEAR_RECIPES = "table/CLEAR_RECIPES";